{
    "ca": {
        "Yes": "Sí",
        "No": "No",
        "Cancel": "Cancel·lar",
        "Close": "Tanca",
        "Clear": "Esborrar",
        "Done": "Fer",
        "Loading": "Carregant ...",
        "Select": "Seleccioneu ...",
        "Search": "Cerca",
        "Back": "esquena",
        "OK": "D'acord",

        "dxCollectionWidget-noDataText": "No hi ha dades a mostrar",

        "dxDropDownEditor-selectLabel": "Seleccionar",

        "validation-required": "Requerit",
        "validation-required-formatted": "{0} és obligatori",
        "validation-numeric": "El valor ha de ser un número",
        "validation-numeric-formatted": "{0} ha de ser un número",
        "validation-range": "El valor està fora de rang",
        "validation-range-formatted": "{0} està fora de rang",
        "validation-stringLength": "La longitud del valor no és correcta",
        "validation-stringLength-formatted": "La longitud de {0} no és correcta",
        "validation-custom": "El valor no és vàlid",
        "validation-custom-formatted": "{0} no és vàlid",
        "validation-async": "El valor no és vàlid",
        "validation-async-formatted": "{0} no és vàlid",
        "validation-compare": "Els valors no coincideixen",
        "validation-compare-formatted": "{0} no coincideix",
        "validation-pattern": "El valor no coincideix amb el patró",
        "validation-pattern-formatted": "{0} no coincideix amb el patró",
        "validation-email": "El correu electrònic no és vàlid",
        "validation-email-formatted": "{0} no és vàlid",
        "validation-mask": "El valor no és vàlid",

        "dxLookup-searchPlaceholder": "Número de caràcter mínim: {0}",

        "dxList-pullingDownText": "Tireu cap avall per refrescar -se ...",
        "dxList-pulledDownText": "Allibereu a refresc ...",
        "dxList-refreshingText": "Refrescant ...",
        "dxList-pageLoadingText": "Carregant ...",
        "dxList-nextButtonText": "Més",
        "dxList-selectAll": "Seleccionar tot",
        "dxListEditDecorator-delete": "Esborrar",
        "dxListEditDecorator-more": "Més",

        "dxScrollView-pullingDownText": "Tireu cap avall per refrescar -se ...",
        "dxScrollView-pulledDownText": "Allibereu a refresc ...",
        "dxScrollView-refreshingText": "Refrescant ...",
        "dxScrollView-reachBottomText": "Carregant ...",

        "dxDateBox-simulatedDataPickerTitleTime": "Seleccioneu l'hora",
        "dxDateBox-simulatedDataPickerTitleDate": "Seleccioneu Data",
        "dxDateBox-simulatedDataPickerTitleDateTime": "Seleccioneu la data i l'hora",
        "dxDateBox-validation-datetime": "El valor ha de ser una data o hora",

        "dxFileUploader-selectFile": "Seleccioneu un fitxer",
        "dxFileUploader-dropFile": "o deixar un fitxer aquí",
        "dxFileUploader-bytes": "bytes",
        "dxFileUploader-kb": "kb",
        "dxFileUploader-Mb": "MB",
        "dxFileUploader-Gb": "GB",
        "dxFileUploader-upload": "Penjar",
        "dxFileUploader-uploaded": "Penjat",
        "dxFileUploader-readyToUpload": "A punt per penjar",
        "dxFileUploader-uploadAbortedMessage": "Pengeu cancel·lat",
        "dxFileUploader-uploadFailedMessage": "La càrrega ha fallat",
        "dxFileUploader-invalidFileExtension": "El tipus de fitxer no està permès",
        "dxFileUploader-invalidMaxFileSize": "El fitxer és massa gran",
        "dxFileUploader-invalidMinFileSize": "El fitxer és massa petit",

        "dxRangeSlider-ariaFrom": "Des de",
        "dxRangeSlider-ariaTill": "Fins a",
        "dxSwitch-switchedOnText": "Al damunt de",
        "dxSwitch-switchedOffText": "Apagada",

        "dxForm-optionalMark": "opcional",
        "dxForm-requiredMessage": "{0} és obligatori",

        "dxNumberBox-invalidValueMessage": "El valor ha de ser un número",
        "dxNumberBox-noDataText": "No hi ha dades",

        "dxDataGrid-columnChooserTitle": "Selector de columnes",
        "dxDataGrid-columnChooserEmptyText": "Arrossegueu una columna aquí per amagar-la",
        "dxDataGrid-groupContinuesMessage": "Continua a la pàgina següent",
        "dxDataGrid-groupContinuedMessage": "Continuat des de la pàgina anterior",
        "dxDataGrid-groupHeaderText": "Grup per aquesta columna",
        "dxDataGrid-ungroupHeaderText": "Desgrupament",
        "dxDataGrid-ungroupAllText": "Ungrup tot",
        "dxDataGrid-editingEditRow": "Preprarar una edició",
        "dxDataGrid-editingSaveRowChanges": "Estalviar",
        "dxDataGrid-editingCancelRowChanges": "Cancel·lar",
        "dxDataGrid-editingDeleteRow": "Esborrar",
        "dxDataGrid-editingUndeleteRow": "Descartar",
        "dxDataGrid-editingConfirmDeleteMessage": "Esteu segur que voleu suprimir aquest registre?",
        "dxDataGrid-validationCancelChanges": "Cancel·la els canvis",
        "dxDataGrid-groupPanelEmptyText": "Arrossegueu una capçalera de columna aquí per agrupar per aquesta columna",
        "dxDataGrid-noDataText": "No hi ha dades",
        "dxDataGrid-searchPanelPlaceholder": "Cerca...",
        "dxDataGrid-filterRowShowAllText": "(Tot)",
        "dxDataGrid-filterRowResetOperationText": "Restablir",
        "dxDataGrid-filterRowOperationEquals": "És igual",
        "dxDataGrid-filterRowOperationNotEquals": "No és igual",
        "dxDataGrid-filterRowOperationLess": "Menys que",
        "dxDataGrid-filterRowOperationLessOrEquals": "Menys o igual a",
        "dxDataGrid-filterRowOperationGreater": "Més gran que",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "Més gran o igual a",
        "dxDataGrid-filterRowOperationStartsWith": "Comença amb",
        "dxDataGrid-filterRowOperationContains": "Conté",
        "dxDataGrid-filterRowOperationNotContains": "No conté",
        "dxDataGrid-filterRowOperationEndsWith": "Acaba amb",
        "dxDataGrid-filterRowOperationBetween": "Entre",
        "dxDataGrid-filterRowOperationBetweenStartText": "Començar",
        "dxDataGrid-filterRowOperationBetweenEndText": "Final",
        "dxDataGrid-applyFilterText": "Aplicar el filtre",
        "dxDataGrid-trueText": "cert",
        "dxDataGrid-falseText": "fals",
        "dxDataGrid-sortingAscendingText": "Ordena ascendent",
        "dxDataGrid-sortingDescendingText": "Ordena descendent",
        "dxDataGrid-sortingClearText": "Netejar ordenació",
        "dxDataGrid-editingSaveAllChanges": "Guardar canvis",
        "dxDataGrid-editingCancelAllChanges": "Descartar els canvis",
        "dxDataGrid-editingAddRow": "Afegiu una fila",
        "dxDataGrid-summaryMin": "Min: {0}",
        "dxDataGrid-summaryMinOtherColumn": "Mínim de {1} és {0}",
        "dxDataGrid-summaryMax": "Max: {0}",
        "dxDataGrid-summaryMaxOtherColumn": "Màxim de {1} és {0}",
        "dxDataGrid-summaryAvg": "Avg: {0}",
        "dxDataGrid-summaryAvgOtherColumn": "Mitjana de {1} és {0}",
        "dxDataGrid-summarySum": "{0}",
        "dxDataGrid-summarySumOtherColumn": "Suma de {1} és {0}",
        "dxDataGrid-summaryCount": "Compte: {0}",
        "dxDataGrid-columnFixingFix": "Ancorar",
        "dxDataGrid-columnFixingUnfix": "Desancorar",
        "dxDataGrid-columnFixingLeftPosition": "A l'esquerra",
        "dxDataGrid-columnFixingRightPosition": "A la dreta",
        "dxDataGrid-exportTo": "Exportació",
        "dxDataGrid-exportToExcel": "Exporta al fitxer Excel",
        "dxDataGrid-exporting": "Exportació ...",
        "dxDataGrid-excelFormat": "Fitxer excel",
        "dxDataGrid-selectedRows": "Files seleccionades",
        "dxDataGrid-exportSelectedRows": "Exporta les files seleccionades a {0}",
        "dxDataGrid-exportAll": "Exporta totes les dades a {0}",
        "dxDataGrid-headerFilterLabel": "Filter options",
        "dxDataGrid-headerFilterIndicatorLabel": "Show filter options for column '{0}'",
        "dxDataGrid-headerFilterEmptyValue": "(Blancs)",
        "dxDataGrid-headerFilterOK": "D'acord",
        "dxDataGrid-headerFilterCancel": "Cancel·lar",
        "dxDataGrid-ariaAdaptiveCollapse": "Amagueu les dades addicionals",
        "dxDataGrid-ariaAdaptiveExpand": "Mostra dades addicionals",
        "dxDataGrid-ariaColumn": "Columna",
        "dxDataGrid-ariaValue": "Valorar",
        "dxDataGrid-ariaFilterCell": "Filtrar la cel·la",
        "dxDataGrid-ariaCollapse": "Col·lapsar",
        "dxDataGrid-ariaExpand": "Expandir",
        "dxDataGrid-ariaDataGrid": "Dades Grim",
        "dxDataGrid-ariaSearchInGrid": "Cerqueu a la graella de dades",
        "dxDataGrid-ariaSelectAll": "Seleccionar tot",
        "dxDataGrid-ariaSelectRow": "Seleccioneu la fila",
        "dxDataGrid-ariaToolbar": "Barra d’eines de quadrícula de dades",
        "dxDataGrid-filterBuilderPopupTitle": "Creador de filtres",
        "dxDataGrid-filterPanelCreateFilter": "Crea un filtre",
        "dxDataGrid-filterPanelClearFilter": "Esborrar filtre",
        "dxDataGrid-filterPanelFilterEnabledHint": "Activa el filtre",

        "dxTreeList-ariaTreeList": "Llista",
        "dxTreeList-ariaSearchInGrid": "Cerqueu a la llista d’arbres",
        "dxTreeList-ariaToolbar": "Barra d’eines de llista d’arbres",
        "dxTreeList-editingAddRowToNode": "Addiccionar",

        "dxPager-infoText": "Pàgina {0} de {1} ({2} ítems)",
        "dxPager-pagesCountText": "de",
        "dxPager-pageSizesAllText": "Tota",
        "dxPager-page": "Pàgina {0}",
        "dxPager-prevPage": "Pàgina anterior",
        "dxPager-nextPage": "Pàgina següent",
        "dxPager-ariaLabel": "Navegació de pàgina",

        "dxPivotGrid-grandTotal": "Total Imal",
        "dxPivotGrid-total": "{0} total",
        "dxPivotGrid-fieldChooserTitle": "Escollit de camp",
        "dxPivotGrid-showFieldChooser": "Mostra el camp de camp",
        "dxPivotGrid-expandAll": "Ampliar tot",
        "dxPivotGrid-collapseAll": "Col·lapsar tot",
        "dxPivotGrid-sortColumnBySummary": "Ordena \"{0}\" per aquesta columna",
        "dxPivotGrid-sortRowBySummary": "Ordena \"{0}\" per aquesta fila",
        "dxPivotGrid-removeAllSorting": "Traieu tota la classificació",
        "dxPivotGrid-dataNotAvailable": "N/a",
        "dxPivotGrid-rowFields": "Camps de fila",
        "dxPivotGrid-columnFields": "Camps de columna",
        "dxPivotGrid-dataFields": "Camps de dades",
        "dxPivotGrid-filterFields": "Camps de filtres",
        "dxPivotGrid-allFields": "Tots els camps",
        "dxPivotGrid-columnFieldArea": "Els camps de columna Drop aquí",
        "dxPivotGrid-dataFieldArea": "Deixar els camps de dades aquí",
        "dxPivotGrid-rowFieldArea": "Els camps de fila de la fila aquí",
        "dxPivotGrid-filterFieldArea": "Els camps de filtre de baixada aquí",

        "dxScheduler-editorLabelTitle": "Assignatura",
        "dxScheduler-editorLabelStartDate": "Data d'inici",
        "dxScheduler-editorLabelEndDate": "Data de finalització",
        "dxScheduler-editorLabelDescription": "Descripció",
        "dxScheduler-editorLabelRecurrence": "Repetir",

        "dxScheduler-openAppointment": "Cita oberta",

        "dxScheduler-recurrenceNever": "Mai",
        "dxScheduler-recurrenceMinutely": "Cada minut",
        "dxScheduler-recurrenceHourly": "Per hora",
        "dxScheduler-recurrenceDaily": "Cada dia",
        "dxScheduler-recurrenceWeekly": "Semanalment",
        "dxScheduler-recurrenceMonthly": "Mensual",
        "dxScheduler-recurrenceYearly": "Any anual",

        "dxScheduler-recurrenceRepeatEvery": "Repetiu tots",
        "dxScheduler-recurrenceRepeatOn": "Repetiu",
        "dxScheduler-recurrenceEnd": "Repetiu final",
        "dxScheduler-recurrenceAfter": "Després",
        "dxScheduler-recurrenceOn": "Al damunt de",

        "dxScheduler-recurrenceRepeatMinutely": "Minut (s)",
        "dxScheduler-recurrenceRepeatHourly": "hora (s)",
        "dxScheduler-recurrenceRepeatDaily": "dia (s)",
        "dxScheduler-recurrenceRepeatWeekly": "Setmana (S)",
        "dxScheduler-recurrenceRepeatMonthly": "mes (s)",
        "dxScheduler-recurrenceRepeatYearly": "any (s)",

        "dxScheduler-switcherDay": "Dia",
        "dxScheduler-switcherWeek": "Setmana",
        "dxScheduler-switcherWorkWeek": "Setmana del treball",
        "dxScheduler-switcherMonth": "Mes",

        "dxScheduler-switcherAgenda": "Agenda",

        "dxScheduler-switcherTimelineDay": "Dia de la Cronologia",
        "dxScheduler-switcherTimelineWeek": "Setmana de la Cronologia",
        "dxScheduler-switcherTimelineWorkWeek": "Setmana del Treball de la Cronologia",
        "dxScheduler-switcherTimelineMonth": "Mes de la línia de temps",

        "dxScheduler-recurrenceRepeatOnDate": "a la data",
        "dxScheduler-recurrenceRepeatCount": "Aparició (s)",
        "dxScheduler-allDay": "Tot el dia",

        "dxScheduler-confirmRecurrenceEditMessage": "Voleu editar només aquesta cita o tota la sèrie?",
        "dxScheduler-confirmRecurrenceDeleteMessage": "Voleu eliminar només aquesta cita o tota la sèrie?",

        "dxScheduler-confirmRecurrenceEditSeries": "Editar la sèrie",
        "dxScheduler-confirmRecurrenceDeleteSeries": "Eliminar la sèrie",
        "dxScheduler-confirmRecurrenceEditOccurrence": "Editar la cita",
        "dxScheduler-confirmRecurrenceDeleteOccurrence": "Suprimeix la cita",

        "dxScheduler-noTimezoneTitle": "Sense zona horària",
        "dxScheduler-moreAppointments": "{0} Més",

        "dxCalendar-todayButtonText": "Avui",
        "dxCalendar-ariaWidgetName": "Calendari",

        "dxColorView-ariaRed": "Vermell",
        "dxColorView-ariaGreen": "Verd",
        "dxColorView-ariaBlue": "Blava",
        "dxColorView-ariaAlpha": "Transparència",
        "dxColorView-ariaHex": "Codi de color",

        "dxTagBox-selected": "{0} seleccionat",
        "dxTagBox-allSelected": "Tot seleccionat ({0})",
        "dxTagBox-moreSelected": "{0} Més",

        "vizExport-printingButtonText": "Imprimir",
        "vizExport-titleMenuText": "Exportació/impressió",
        "vizExport-exportButtonText": "{0} fitxer",

        "dxFilterBuilder-and": "I",
        "dxFilterBuilder-or": "O",
        "dxFilterBuilder-notAnd": "No i",
        "dxFilterBuilder-notOr": "No o",
        "dxFilterBuilder-addCondition": "Afegiu la condició",
        "dxFilterBuilder-addGroup": "Afegiu grup",
        "dxFilterBuilder-enterValueText": "<Introduïu un valor>",
        "dxFilterBuilder-filterOperationEquals": "És igual",
        "dxFilterBuilder-filterOperationNotEquals": "No és igual",
        "dxFilterBuilder-filterOperationLess": "És menys que",
        "dxFilterBuilder-filterOperationLessOrEquals": "És inferior o igual a",
        "dxFilterBuilder-filterOperationGreater": "És més gran que",
        "dxFilterBuilder-filterOperationGreaterOrEquals": "És superior o igual a",
        "dxFilterBuilder-filterOperationStartsWith": "Comença amb",
        "dxFilterBuilder-filterOperationContains": "Conté",
        "dxFilterBuilder-filterOperationNotContains": "No conté",
        "dxFilterBuilder-filterOperationEndsWith": "Acaba amb",
        "dxFilterBuilder-filterOperationIsBlank": "Està en blanc",
        "dxFilterBuilder-filterOperationIsNotBlank": "No està en blanc",
        "dxFilterBuilder-filterOperationBetween": "És entre",
        "dxFilterBuilder-filterOperationAnyOf": "És alguna de",
        "dxFilterBuilder-filterOperationNoneOf": "No és cap",

        "dxHtmlEditor-dialogColorCaption": "Canvia el color de la lletra",
        "dxHtmlEditor-dialogBackgroundCaption": "Canvieu el color de fons",
        "dxHtmlEditor-dialogLinkCaption": "L’enllaç afegit",
        "dxHtmlEditor-dialogLinkUrlField": "Url",
        "dxHtmlEditor-dialogLinkTextField": "Text",
        "dxHtmlEditor-dialogLinkTargetField": "Obriu l'enllaç a la finestra nova",
        "dxHtmlEditor-dialogImageCaption": "Afegiu imatge",
        "dxHtmlEditor-dialogImageUrlField": "Url",
        "dxHtmlEditor-dialogImageAltField": "Text alternatiu",
        "dxHtmlEditor-dialogImageWidthField": "Amplada (PX)",
        "dxHtmlEditor-dialogImageHeightField": "Alçada (PX)",
        "dxHtmlEditor-dialogInsertTableRowsField": "Fileres",
        "dxHtmlEditor-dialogInsertTableColumnsField": "Columnes",
        "dxHtmlEditor-dialogInsertTableCaption": "Inseriu la taula",
        "dxHtmlEditor-dialogUpdateImageCaption": "Imatge d'actualització",
        "dxHtmlEditor-dialogImageUpdateButton": "Actualitzar",
        "dxHtmlEditor-dialogImageAddButton": "Afegir",
        "dxHtmlEditor-dialogImageSpecifyUrl": "Des del web",
        "dxHtmlEditor-dialogImageSelectFile": "Des d’aquest dispositiu",
        "dxHtmlEditor-dialogImageKeepAspectRatio": "Mantenir la relació d'aspecte",
        "dxHtmlEditor-dialogImageEncodeToBase64": "Codificar a la base64",
        "dxHtmlEditor-heading": "Títol",
        "dxHtmlEditor-normalText": "Text normal",
        "dxHtmlEditor-background": "Color de fons",
        "dxHtmlEditor-bold": "Negreta",
        "dxHtmlEditor-color": "Color de la lletra",
        "dxHtmlEditor-font": "Font",
        "dxHtmlEditor-italic": "En cursiva",
        "dxHtmlEditor-link": "L’enllaç afegit",
        "dxHtmlEditor-image": "Afegiu imatge",
        "dxHtmlEditor-size": "Tamany",
        "dxHtmlEditor-strike": "Strikethrough",
        "dxHtmlEditor-subscript": "Subscripció",
        "dxHtmlEditor-superscript": "Superíndex",
        "dxHtmlEditor-underline": "Subratllar",
        "dxHtmlEditor-blockquote": "Blockquote",
        "dxHtmlEditor-header": "Capçalera",
        "dxHtmlEditor-increaseIndent": "Augmentar el sagnat",
        "dxHtmlEditor-decreaseIndent": "Disminuir el sagnat",
        "dxHtmlEditor-orderedList": "Llista ordenada",
        "dxHtmlEditor-bulletList": "Llista de bala",
        "dxHtmlEditor-alignLeft": "Alinear a l'esquerra",
        "dxHtmlEditor-alignCenter": "Alinear centre",
        "dxHtmlEditor-alignRight": "Alinear la dreta",
        "dxHtmlEditor-alignJustify": "Alinear Justify",
        "dxHtmlEditor-codeBlock": "Bloc de codis",
        "dxHtmlEditor-variable": "Afegiu la variable",
        "dxHtmlEditor-undo": "Desfer",
        "dxHtmlEditor-redo": "Tornar",
        "dxHtmlEditor-clear": "Format clar",
        "dxHtmlEditor-insertTable": "Inseriu la taula",
        "dxHtmlEditor-insertHeaderRow": "Inseriu la fila de capçalera",
        "dxHtmlEditor-insertRowAbove": "Inseriu la fila a sobre",
        "dxHtmlEditor-insertRowBelow": "Inseriu la fila a sota",
        "dxHtmlEditor-insertColumnLeft": "Inseriu la columna a l'esquerra",
        "dxHtmlEditor-insertColumnRight": "Inseriu la columna dreta",
        "dxHtmlEditor-deleteColumn": "Suprimeix la columna",
        "dxHtmlEditor-deleteRow": "Suprimeix la fila",
        "dxHtmlEditor-deleteTable": "Suprimeix la taula",
        "dxHtmlEditor-cellProperties": "Propietats de la cel·la",
        "dxHtmlEditor-tableProperties": "Propietats de la taula",
        "dxHtmlEditor-insert": "Inserir",
        "dxHtmlEditor-delete": "Esborrar",
        "dxHtmlEditor-border": "Marge",
        "dxHtmlEditor-style": "Estil",
        "dxHtmlEditor-width": "Amplada",
        "dxHtmlEditor-height": "Altura",
        "dxHtmlEditor-borderColor": "Color",
        "dxHtmlEditor-tableBackground": "Fons",
        "dxHtmlEditor-dimensions": "Dimensions",
        "dxHtmlEditor-alignment": "Alineació",
        "dxHtmlEditor-horizontal": "Horitzontal",
        "dxHtmlEditor-vertical": "Vertical",
        "dxHtmlEditor-paddingVertical": "Encoixinat vertical",
        "dxHtmlEditor-paddingHorizontal": "Encoixinat horitzontal",
        "dxHtmlEditor-pixels": "Píxels",
        "dxHtmlEditor-list": "Inscriure",
        "dxHtmlEditor-ordered": "Ordenat",
        "dxHtmlEditor-bullet": "Bala",
        "dxHtmlEditor-align": "Alinear",
        "dxHtmlEditor-center": "Centre",
        "dxHtmlEditor-left": "Esquerre",
        "dxHtmlEditor-right": "Dret",
        "dxHtmlEditor-indent": "Sagnat",
        "dxHtmlEditor-justify": "Justificar",

        "dxFileManager-newDirectoryName": "Directori sense títol",
        "dxFileManager-rootDirectoryName": "Fitxers",
        "dxFileManager-errorNoAccess": "Accés denegat. L'operació no s'ha pogut completar.",
        "dxFileManager-errorDirectoryExistsFormat": "El directori '{0}' ja existeix.",
        "dxFileManager-errorFileExistsFormat": "El fitxer '{0}' ja existeix.",
        "dxFileManager-errorFileNotFoundFormat": "Fitxer '{0}' No es troba.",
        "dxFileManager-errorDirectoryNotFoundFormat": "Directori '{0}' No es troba.",
        "dxFileManager-errorWrongFileExtension": "L'extensió del fitxer no està permesa.",
        "dxFileManager-errorMaxFileSizeExceeded": "La mida del fitxer supera la mida màxima permesa.",
        "dxFileManager-errorInvalidSymbols": "Aquest nom conté caràcters no vàlids.",
        "dxFileManager-errorDefault": "Error no especificat.",
        "dxFileManager-errorDirectoryOpenFailed": "El directori no es pot obrir",

        "dxFileManager-commandCreate": "Nou directori",
        "dxFileManager-commandRename": "Reanomenar",
        "dxFileManager-commandMove": "Moure's cap a",
        "dxFileManager-commandCopy": "Copiar a",
        "dxFileManager-commandDelete": "Esborrar",
        "dxFileManager-commandDownload": "Descarregar",
        "dxFileManager-commandUpload": "Pengeu fitxers",
        "dxFileManager-commandRefresh": "Actualització",
        "dxFileManager-commandThumbnails": "Vista de les miniatures",
        "dxFileManager-commandDetails": "Veure detalls",
        "dxFileManager-commandClearSelection": "Netejar selecció",
        "dxFileManager-commandShowNavPane": "Panell de navegació de commutació",

        "dxFileManager-dialogDirectoryChooserMoveTitle": "Moure's cap a",
        "dxFileManager-dialogDirectoryChooserMoveButtonText": "Moure",
        "dxFileManager-dialogDirectoryChooserCopyTitle": "Copiar a",
        "dxFileManager-dialogDirectoryChooserCopyButtonText": "Còpia",
        "dxFileManager-dialogRenameItemTitle": "Reanomenar",
        "dxFileManager-dialogRenameItemButtonText": "Estalviar",
        "dxFileManager-dialogCreateDirectoryTitle": "Nou directori",
        "dxFileManager-dialogCreateDirectoryButtonText": "Crear",
        "dxFileManager-dialogDeleteItemTitle": "Esborrar",
        "dxFileManager-dialogDeleteItemButtonText": "Esborrar",
        "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Esteu segur que voleu suprimir {0}?",
        "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Esteu segur que voleu suprimir els elements {0}?",
        "dxFileManager-dialogButtonCancel": "Cancel·lar",

        "dxFileManager-editingCreateSingleItemProcessingMessage": "Creació d’un directori a {0}",
        "dxFileManager-editingCreateSingleItemSuccessMessage": "Creat un directori dins {0}",
        "dxFileManager-editingCreateSingleItemErrorMessage": "El directori no es va crear",
        "dxFileManager-editingCreateCommonErrorMessage": "El directori no es va crear",

        "dxFileManager-editingRenameSingleItemProcessingMessage": "Canviant el nom d'un element dins de {0}",
        "dxFileManager-editingRenameSingleItemSuccessMessage": "Canvia el nom d'un element dins de {0}",
        "dxFileManager-editingRenameSingleItemErrorMessage": "L'article no es va canviar de nom",
        "dxFileManager-editingRenameCommonErrorMessage": "L'article no es va canviar de nom",

        "dxFileManager-editingDeleteSingleItemProcessingMessage": "Suprimir un element de {0}",
        "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Eliminació {0} ítems de {1}",
        "dxFileManager-editingDeleteSingleItemSuccessMessage": "S'ha suprimit un element de {0}",
        "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Eliminat {0} ítems de {1}",
        "dxFileManager-editingDeleteSingleItemErrorMessage": "L'article no s'ha suprimit",
        "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} Els articles no es van eliminar",
        "dxFileManager-editingDeleteCommonErrorMessage": "Alguns articles no es van eliminar",

        "dxFileManager-editingMoveSingleItemProcessingMessage": "Moure un element a {0}",
        "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} ítems a {1}",
        "dxFileManager-editingMoveSingleItemSuccessMessage": "Va traslladar un element a {0}",
        "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Els articles motats {0} a {1}",
        "dxFileManager-editingMoveSingleItemErrorMessage": "L'article no es va moure",
        "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} Els articles no es van moure",
        "dxFileManager-editingMoveCommonErrorMessage": "Alguns articles no es van moure",

        "dxFileManager-editingCopySingleItemProcessingMessage": "Copiar un element a {0}",
        "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Còpia {0} ítems a {1}",
        "dxFileManager-editingCopySingleItemSuccessMessage": "Va copiar un element a {0}",
        "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copiat {0} ítems a {1}",
        "dxFileManager-editingCopySingleItemErrorMessage": "L'article no es va copiar",
        "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} Els articles no es van copiar",
        "dxFileManager-editingCopyCommonErrorMessage": "Alguns articles no es van copiar",

        "dxFileManager-editingUploadSingleItemProcessingMessage": "Carregant un element a {0}",
        "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Pujar els elements {0} a {1}",
        "dxFileManager-editingUploadSingleItemSuccessMessage": "Va penjar un element a {0}",
        "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Carregat {0} articles a {1}",
        "dxFileManager-editingUploadSingleItemErrorMessage": "L'article no s'ha penjat",
        "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} Els articles no es van penjar",
        "dxFileManager-editingUploadCanceledMessage": "Cancel·lat",

        "dxFileManager-editingDownloadSingleItemErrorMessage": "L'article no s'ha descarregat",
        "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} Els articles no es van descarregar",

        "dxFileManager-listDetailsColumnCaptionName": "Nom",
        "dxFileManager-listDetailsColumnCaptionDateModified": "Actualització",
        "dxFileManager-listDetailsColumnCaptionFileSize": "Mida",

        "dxFileManager-listThumbnailsTooltipTextSize": "Mida",
        "dxFileManager-listThumbnailsTooltipTextDateModified": "Actualització",

        "dxFileManager-notificationProgressPanelTitle": "Progrés, progressar",
        "dxFileManager-notificationProgressPanelEmptyListText": "Sense operacions",
        "dxFileManager-notificationProgressPanelOperationCanceled": "Cancel·lat",

        "dxDiagram-categoryGeneral": "General",
        "dxDiagram-categoryFlowchart": "Diagrama de flux",
        "dxDiagram-categoryOrgChart": "Gràfic org",
        "dxDiagram-categoryContainers": "Contenidors",
        "dxDiagram-categoryCustom": "Costum",

        "dxDiagram-commandExportToSvg": "Exporta a SVG",
        "dxDiagram-commandExportToPng": "Exporta a PNG",
        "dxDiagram-commandExportToJpg": "Exporta a JPEG",
        "dxDiagram-commandUndo": "Desfer",
        "dxDiagram-commandRedo": "Tornar",
        "dxDiagram-commandFontName": "Nom del tipus de lletra",
        "dxDiagram-commandFontSize": "Mida de la font",
        "dxDiagram-commandBold": "Atrevida",
        "dxDiagram-commandItalic": "En cursiva",
        "dxDiagram-commandUnderline": "Subratllar",
        "dxDiagram-commandTextColor": "Color de la lletra",
        "dxDiagram-commandLineColor": "Color de la línia",
        "dxDiagram-commandLineWidth": "Amplada de la línia",
        "dxDiagram-commandLineStyle": "Estil de línia",
        "dxDiagram-commandLineStyleSolid": "Sòlid",
        "dxDiagram-commandLineStyleDotted": "Puntejat",
        "dxDiagram-commandLineStyleDashed": "Guiat",
        "dxDiagram-commandFillColor": "Ompliu el color",
        "dxDiagram-commandAlignLeft": "Alinear a l'esquerra",
        "dxDiagram-commandAlignCenter": "Alinear centre",
        "dxDiagram-commandAlignRight": "Alinear la dreta",
        "dxDiagram-commandConnectorLineType": "Tipus de línia de connector",
        "dxDiagram-commandConnectorLineStraight": "Directament",
        "dxDiagram-commandConnectorLineOrthogonal": "Ortogonal",
        "dxDiagram-commandConnectorLineStart": "Inici de la línia del connector",
        "dxDiagram-commandConnectorLineEnd": "Final de la línia de connector",
        "dxDiagram-commandConnectorLineNone": "Res",
        "dxDiagram-commandConnectorLineArrow": "Fletxa",
        "dxDiagram-commandFullscreen": "Pantalla completa",
        "dxDiagram-commandUnits": "Unitats",
        "dxDiagram-commandPageSize": "Mida de la pàgina",
        "dxDiagram-commandPageOrientation": "Orientació a la pàgina",
        "dxDiagram-commandPageOrientationLandscape": "Paisatge",
        "dxDiagram-commandPageOrientationPortrait": "Retrat",
        "dxDiagram-commandPageColor": "Color de la pàgina",
        "dxDiagram-commandShowGrid": "Mostra la graella",
        "dxDiagram-commandSnapToGrid": "Enganxar -se a la graella",
        "dxDiagram-commandGridSize": "Mida de la graella",
        "dxDiagram-commandZoomLevel": "Nivell de zoom",
        "dxDiagram-commandAutoZoom": "Zoom automàtic",
        "dxDiagram-commandFitToContent": "Adaptat al contingut",
        "dxDiagram-commandFitToWidth": "Adaptat a l'amplada",
        "dxDiagram-commandAutoZoomByContent": "Zoom automàtic per contingut",
        "dxDiagram-commandAutoZoomByWidth": "Zoom automàtic per amplada",
        "dxDiagram-commandSimpleView": "Vista senzilla",
        "dxDiagram-commandCut": "Tallar",
        "dxDiagram-commandCopy": "Còpia",
        "dxDiagram-commandPaste": "Pasta",
        "dxDiagram-commandSelectAll": "Seleccionar tot",
        "dxDiagram-commandDelete": "Esborrar",
        "dxDiagram-commandBringToFront": "Porta al front",
        "dxDiagram-commandSendToBack": "Envia a Back",
        "dxDiagram-commandLock": "Tancar",
        "dxDiagram-commandUnlock": "Descobrir",
        "dxDiagram-commandInsertShapeImage": "Inseriu la imatge ...",
        "dxDiagram-commandEditShapeImage": "Canvia la imatge ...",
        "dxDiagram-commandDeleteShapeImage": "Esborra la imatge",
        "dxDiagram-commandLayoutLeftToRight": "Esquerra a dreta",
        "dxDiagram-commandLayoutRightToLeft": "Dret a esquerra",
        "dxDiagram-commandLayoutTopToBottom": "De dalt a baix",
        "dxDiagram-commandLayoutBottomToTop": "De baix a la part superior",

        "dxDiagram-unitIn": "dins de",
        "dxDiagram-unitCm": "cm",
        "dxDiagram-unitPx": "px",

        "dxDiagram-dialogButtonOK": "D'acord",
        "dxDiagram-dialogButtonCancel": "Cancel·lar",
        "dxDiagram-dialogInsertShapeImageTitle": "Inseriu la imatge",
        "dxDiagram-dialogEditShapeImageTitle": "Canvieu la imatge",
        "dxDiagram-dialogEditShapeImageSelectButton": "Seleccioneu la imatge",
        "dxDiagram-dialogEditShapeImageLabelText": "o deixar un fitxer aquí",

        "dxDiagram-uiExport": "Exportació",
        "dxDiagram-uiProperties": "Propietats",
        "dxDiagram-uiSettings": "Configuració",
        "dxDiagram-uiShowToolbox": "Mostra la caixa d’eines",
        "dxDiagram-uiSearch": "Cerca",
        "dxDiagram-uiStyle": "Estil",
        "dxDiagram-uiLayout": "Pla",
        "dxDiagram-uiLayoutTree": "Arbre",
        "dxDiagram-uiLayoutLayered": "En capes",
        "dxDiagram-uiDiagram": "Diagrama",
        "dxDiagram-uiText": "Text",
        "dxDiagram-uiObject": "Objecte",
        "dxDiagram-uiConnector": "Connector",
        "dxDiagram-uiPage": "Pàgina",

        "dxDiagram-shapeText": "Text",
        "dxDiagram-shapeRectangle": "Rectangle",
        "dxDiagram-shapeEllipse": "El·lipse",
        "dxDiagram-shapeCross": "Creu",
        "dxDiagram-shapeTriangle": "Triangle",
        "dxDiagram-shapeDiamond": "Diamant",
        "dxDiagram-shapeHeart": "Cor",
        "dxDiagram-shapePentagon": "Pentàgon",
        "dxDiagram-shapeHexagon": "Hexàgon",
        "dxDiagram-shapeOctagon": "Octàgon",
        "dxDiagram-shapeStar": "Estrella",
        "dxDiagram-shapeArrowLeft": "Fletxa esquerra",
        "dxDiagram-shapeArrowUp": "Fletxa cap amunt",
        "dxDiagram-shapeArrowRight": "Fletxa dreta",
        "dxDiagram-shapeArrowDown": "Fletxa cap avall",
        "dxDiagram-shapeArrowUpDown": "Fletxa cap avall",
        "dxDiagram-shapeArrowLeftRight": "Fletxa esquerra dreta",
        "dxDiagram-shapeProcess": "Elaborar",
        "dxDiagram-shapeDecision": "Decisió",
        "dxDiagram-shapeTerminator": "Terminador",
        "dxDiagram-shapePredefinedProcess": "Procés predefinit",
        "dxDiagram-shapeDocument": "Document",
        "dxDiagram-shapeMultipleDocuments": "Diversos documents",
        "dxDiagram-shapeManualInput": "Entrada manual",
        "dxDiagram-shapePreparation": "Preparació",
        "dxDiagram-shapeData": "Dades",
        "dxDiagram-shapeDatabase": "Base de dades",
        "dxDiagram-shapeHardDisk": "Disc dur",
        "dxDiagram-shapeInternalStorage": "Almacenament intern",
        "dxDiagram-shapePaperTape": "Cinta paperera",
        "dxDiagram-shapeManualOperation": "Funcionament manual",
        "dxDiagram-shapeDelay": "Retard",
        "dxDiagram-shapeStoredData": "Dades emmagatzemades",
        "dxDiagram-shapeDisplay": "Exposició",
        "dxDiagram-shapeMerge": "Fusionar",
        "dxDiagram-shapeConnector": "Connector",
        "dxDiagram-shapeOr": "O",
        "dxDiagram-shapeSummingJunction": "Resumió de la unió",
        "dxDiagram-shapeContainerDefaultText": "Contenidor",
        "dxDiagram-shapeVerticalContainer": "Contenidor vertical",
        "dxDiagram-shapeHorizontalContainer": "Contenidor horitzontal",
        "dxDiagram-shapeCardDefaultText": "Nom de la persona",
        "dxDiagram-shapeCardWithImageOnLeft": "Targeta amb imatge a l’esquerra",
        "dxDiagram-shapeCardWithImageOnTop": "Targeta amb imatge a la part superior",
        "dxDiagram-shapeCardWithImageOnRight": "Targeta amb imatge a la dreta",

        "dxGantt-dialogTitle": "Títol",
        "dxGantt-dialogStartTitle": "Començar",
        "dxGantt-dialogEndTitle": "Final",
        "dxGantt-dialogProgressTitle": "Progrés, progressar",
        "dxGantt-dialogResourcesTitle": "Recursos",
        "dxGantt-dialogResourceManagerTitle": "Gestor d'obres",
        "dxGantt-dialogTaskDetailsTitle": "Detalls de la tasca",
        "dxGantt-dialogEditResourceListHint": "Edita la llista de recursos",
        "dxGantt-dialogEditNoResources": "Sense recursos",
        "dxGantt-dialogButtonAdd": "Addiccionar",
        "dxGantt-contextMenuNewTask": "Nova tasca",
        "dxGantt-contextMenuNewSubtask": "Nou Subtak",
        "dxGantt-contextMenuDeleteTask": "Esborra la tasca",
        "dxGantt-contextMenuDeleteDependency": "Suprimeix la dependència",
        "dxGantt-dialogTaskDeleteConfirmation": "Eliminar una tasca també suprimeix totes les seves dependències i subtasces. Esteu segur que voleu suprimir aquesta tasca?",
        "dxGantt-dialogDependencyDeleteConfirmation": "Esteu segur que voleu suprimir la dependència de la tasca?",
        "dxGantt-dialogResourcesDeleteConfirmation": "Eliminar un recurs també el suprimeix de les tasques a les quals s’assigna aquest recurs. Esteu segur que voleu suprimir aquests recursos? Recursos: {0}",
        "dxGantt-dialogConstraintCriticalViolationMessage": "La tasca que intenteu moure està vinculada a una segona tasca mitjançant una relació de dependència. Aquest canvi entrava en conflicte amb les regles de dependència. Com voldríeu continuar?",
        "dxGantt-dialogConstraintViolationMessage": "La tasca que intenteu moure està vinculada a una segona tasca mitjançant una relació de dependència. Com voldríeu continuar?",
        "dxGantt-dialogCancelOperationMessage": "Cancel·la l'operació",
        "dxGantt-dialogDeleteDependencyMessage": "Suprimeix la dependència",
        "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Moure la tasca i mantenir la dependència",
        "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "La tasca que intenteu moure està vinculada a una altra tasca mitjançant les relacions de dependència. Aquest canvi entrava en conflicte amb les regles de dependència. Com voldríeu continuar?",
        "dxGantt-dialogConstraintViolationSeveralTasksMessage": "La tasca que intenteu moure està vinculada a una altra tasca mitjançant les relacions de dependència. Com voldríeu continuar?",
        "dxGantt-dialogDeleteDependenciesMessage": "Suprimeix les relacions de dependència",
        "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Moure la tasca i mantenir les dependències",
        "dxGantt-undo": "Desfer",
        "dxGantt-redo": "Tornar",
        "dxGantt-expandAll": "Ampliar tot",
        "dxGantt-collapseAll": "Col·lapsar tot",
        "dxGantt-addNewTask": "Afegiu una nova tasca",
        "dxGantt-deleteSelectedTask": "Suprimeix la tasca seleccionada",
        "dxGantt-zoomIn": "Ampliar",
        "dxGantt-zoomOut": "Disminuir el zoom",
        "dxGantt-fullScreen": "Pantalla completa",
        "dxGantt-quarter": "Q {0}",
        "dxGantt-sortingAscendingText": "Ordena Ascending",
        "dxGantt-sortingDescendingText": "Ordena descendent",
        "dxGantt-sortingClearText": "Ordenació clara",
        "dxGantt-showResources": "Mostrar recursos",
        "dxGantt-showDependencies": "Mostrar dependències",
        "dxGantt-dialogStartDateValidation": "La data d'inici ha de ser després de {0}",
        "dxGantt-dialogEndDateValidation": "La data de finalització ha de ser després de {0}"
    }
}
